import { a as getGroupById, i as getUserGroups, n as getUsersByGroupWithRole, o as getAllGroups, r as getUsersByGroup, t as getUsersPaginated1 } from "./getUsersPaginated1.js";
import { queryOptions, useQuery } from "@tanstack/react-query";
//#region src/__generated__/auth/group/hooks/useGetAllGroups.ts
const getAllGroupsQueryKey = ({ query } = {}) => [{ url: "/auth/proxy/group" }, ...query ? [query] : []];
function getAllGroupsQueryOptions({ query } = {}, config = {}) {
	const queryKey = getAllGroupsQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getAllGroups({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список групп.
* {@link /auth/proxy/group}
*/
function useGetAllGroups({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getAllGroupsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getAllGroupsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/group/hooks/useGetGroupById.ts
const getGroupByIdQueryKey = ({ path }) => [{
	url: "/auth/proxy/group/:groupId",
	params: path
}];
function getGroupByIdQueryOptions({ path }, config = {}) {
	const queryKey = getGroupByIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getGroupById({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть группу по id.
* {@link /auth/proxy/group/:groupId}
*/
function useGetGroupById({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getGroupByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getGroupByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/group/hooks/useGetUserGroups.ts
const getUserGroupsQueryKey = ({ path }) => [{
	url: "/auth/proxy/group/user/:userId",
	params: path
}];
function getUserGroupsQueryOptions({ path }, config = {}) {
	const queryKey = getUserGroupsQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUserGroups({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список групп пользователя по id пользователя.
* {@link /auth/proxy/group/user/:userId}
*/
function useGetUserGroups({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getUserGroupsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUserGroupsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/group/hooks/useGetUsersByGroup.ts
const getUsersByGroupQueryKey = ({ path }) => [{
	url: "/auth/proxy/group/:groupId/members",
	params: path
}];
function getUsersByGroupQueryOptions({ path }, config = {}) {
	const queryKey = getUsersByGroupQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUsersByGroup({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список пользователей по id группы.
* {@link /auth/proxy/group/:groupId/members}
*/
function useGetUsersByGroup({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getUsersByGroupQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUsersByGroupQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/group/hooks/useGetUsersByGroupWithRole.ts
const getUsersByGroupWithRoleQueryKey = ({ path, query }) => [{
	url: "/auth/proxy/group/:groupId/members/role",
	params: path
}, ...query ? [query] : []];
function getUsersByGroupWithRoleQueryOptions({ path, query }, config = {}) {
	const queryKey = getUsersByGroupWithRoleQueryKey({
		path,
		query
	});
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUsersByGroupWithRole({
				...config,
				path,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список пользователей по id группы с определённой ролью переданной в реквесте.
* {@link /auth/proxy/group/:groupId/members/role}
*/
function useGetUsersByGroupWithRole({ path, query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = {
		path: typeof path === "function" ? path() : path,
		query: typeof query === "function" ? query() : query
	};
	const queryKey = resolvedOptions?.queryKey ?? getUsersByGroupWithRoleQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUsersByGroupWithRoleQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/group/hooks/useGetUsersPaginated1.ts
const getUsersPaginated1QueryKey = ({ query } = {}) => [{ url: "/auth/proxy/group/paginated" }, ...query ? [query] : []];
function getUsersPaginated1QueryOptions({ query } = {}, config = {}) {
	const queryKey = getUsersPaginated1QueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUsersPaginated1({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Поиск по названию и пагинация организаций.
* {@link /auth/proxy/group/paginated}
*/
function useGetUsersPaginated1({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getUsersPaginated1QueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUsersPaginated1QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { getAllGroupsQueryOptions as _, getUsersByGroupWithRoleQueryOptions as a, getUsersByGroupQueryOptions as c, getUserGroupsQueryOptions as d, useGetUserGroups as f, getAllGroupsQueryKey as g, useGetGroupById as h, getUsersByGroupWithRoleQueryKey as i, useGetUsersByGroup as l, getGroupByIdQueryOptions as m, getUsersPaginated1QueryOptions as n, useGetUsersByGroupWithRole as o, getGroupByIdQueryKey as p, useGetUsersPaginated1 as r, getUsersByGroupQueryKey as s, getUsersPaginated1QueryKey as t, getUserGroupsQueryKey as u, useGetAllGroups as v };

//# sourceMappingURL=useGetUsersPaginated1.js.map